export const advanceTimeOptions = [
  { value: "15", label: "15 minutes" },
  { value: "30", label: "30 minutes" },
  { value: "60", label: "1 hour" },
  { value: "120", label: "2 hours" },
  { value: "240", label: "4 hours" },
  { value: "480", label: "8 hours" },
  { value: "1440", label: "1 day" },
  { value: "2880", label: "2 days" },
  { value: "4320", label: "3 days" },
  { value: "5760", label: "4 days" },
  { value: "7200", label: "5 days" },
  { value: "8640", label: "6 days" },
  { value: "10080", label: "7 days" },
  { value: "11520", label: "8 days" },
  { value: "12960", label: "9 days" },
  { value: "14400", label: "10 days" },
];

// Default values for advance time configuration
// These are used across form initialization and migration logic
export const DEFAULT_MIN_ADVANCE_TIME = 15; // 15 minutes
export const DEFAULT_MAX_ADVANCE_TIME = 1440; // 1 day (24 hours)
export const LEGACY_MAX_ADVANCE_TIME_FALLBACK = 4320; // 3 days - used for migrating old alerts

export const minimumEventDurationOptions = [
  { value: 15, label: "15 minutes", unit: "minutes" as const },
  { value: 30, label: "30 minutes", unit: "minutes" as const },
  { value: 45, label: "45 minutes", unit: "minutes" as const },
  { value: 60, label: "1 hour", unit: "hours" as const },
  { value: 120, label: "2 hours", unit: "hours" as const },
  { value: 180, label: "3 hours", unit: "hours" as const },
  { value: 240, label: "4 hours", unit: "hours" as const },
  { value: 300, label: "5 hours", unit: "hours" as const },
  { value: 360, label: "6 hours", unit: "hours" as const },
];

// Discrete allowed values for advance time slider (in minutes)
// User can only select these specific values - no in-between values allowed
export const advanceTimeAllowedValues = [
  15,    // 15min - index 0
  30,    // 30min - index 1
  60,    // 1h - index 2
  120,   // 2h - index 3
  240,   // 4h - index 4
  480,   // 8h - index 5
  1440,  // 1d - index 6
  2880,  // 2d - index 7
  4320,  // 3d - index 8
  5760,  // 4d - index 9
  7200,  // 5d - index 10
  8640,  // 6d - index 11
  10080, // 7d - index 12
  11520, // 8d - index 13
  12960, // 9d - index 14
  14400, // 10d - index 15
];

// Slider marks use indices (0-15) for uniform spacing
// Only showing some labels to avoid text overlap
export const advanceTimeSliderMarks = [
  { value: 0, label: "15min" },
  { value: 1, label: "" },
  { value: 2, label: "1h" },
  { value: 3, label: "" },
  { value: 4, label: "4h" },
  { value: 5, label: "" },
  { value: 6, label: "1d" },
  { value: 7, label: "" },
  { value: 8, label: "3d" },
  { value: 9, label: "" },
  { value: 10, label: "5d" },
  { value: 11, label: "" },
  { value: 12, label: "7d" },
  { value: 13, label: "" },
  { value: 14, label: "" },
  { value: 15, label: "10d" },
];

// Time range slider marks for day period (00:00 - 23:59)
export const timeRangeSliderMarks = [
  { value: 0, label: "00:00" },
  { value: 6, label: "06:00" },
  { value: 12, label: "12:00" },
  { value: 18, label: "18:00" },
  { value: 24, label: "23:59" },
];
